import "./styles.css";
import NeedAssessComponent from "./Components/NeedAssessComponent/NeedAssessComponent";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import MicIcon from "@mui/icons-material/Mic";
import GppGoodIcon from "@mui/icons-material/GppGood";
import { Button, Divider, Typography, Box } from "@mui/material";
import { useState, useEffect } from "react";
import GrantPermissionsStepsDialog from "../../components/GrantPermissionsStepsDialog/GrantPermissionsStepsDialog";
import { useTranslationSetup } from "../../utils/useTranslationSetup.js";
import PermissionsStatusLoader from "./Components/PermissionsStatusLoader/PermissionsStatusLoader";
import CloudOrange from "../../assets/cloud-orange.svg";
import CloudPurple from "../../assets/purple-cloud.svg";
import CloudPink from "../../assets/pink-cloud.svg";
import { SCREENS } from "../../utils/CommonUtils/screenConstants.js";

const NeedPermissionsScreen = ({
  setActiveScreen,
  setLatitude,
  setLongitude,
  setAudioPermissionStatus,
  setLocationPermissionStatus,
}) => {
  const { t } = useTranslationSetup();
  const [audioPermissions, setAudioPermissions] = useState(null);
  const [locationPermissions, setLocationPermissions] = useState(null);
  const [
    openPermissionsInformationDialog,
    setOpenPermissionsInformationDialog,
  ] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    if (audioPermissions !== null && locationPermissions !== null) {
      setShowLoader(false);
    }
    if (
      audioPermissions !== null &&
      locationPermissions !== null &&
      (audioPermissions === "DENIED" || locationPermissions === "DENIED")
    ) {
      setOpenPermissionsInformationDialog(true);
    }
    if (audioPermissions === "GRANTED" && locationPermissions === "GRANTED") {
      setActiveScreen(SCREENS.RENDER_ASSESSMENT_LANG_SCREEN);
      setAudioPermissionStatus("GRANTED");
      setLocationPermissionStatus("GRANTED");
      setActiveScreen(SCREENS.RENDER_ASSESSMENT_LANG_SCREEN);
    }
  }, [audioPermissions, locationPermissions]);

  function askAudioPermissions() {
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(function (stream) {
        setAudioPermissions("GRANTED");
        stream.getTracks().forEach((track) => track.stop());
      })
      .catch(function () {
        setAudioPermissions("DENIED");
      });
  }

  function askGeolocationPermissions() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
          setLocationPermissions("GRANTED");
        },
        () => {
          setLocationPermissions("DENIED");
        }
      );
    } else {
      setLocationPermissions("GEOLOCATION_NOT_SUPPORTED");
    }
  }

  function askPermissions() {
    setShowLoader(true);
    askGeolocationPermissions();
    askAudioPermissions();
  }

  return (
    <Box className="need-permissions-container">
      <PermissionsStatusLoader open={showLoader} />
      <GrantPermissionsStepsDialog
        isDialogOpen={openPermissionsInformationDialog}
        setIsDialogOpen={setOpenPermissionsInformationDialog}
      />
      <Box className="need-permissions-cloud">
        <img className="pink-cloud" src={CloudPink} alt="clouds" />
        <img className="purple-cloud" src={CloudPurple} alt="clouds" />
      </Box>
      <Box className="need-permissions-wrapper">
        <Box className="need-permissions-content">
          <Typography className="need-permissions-screen-heading">
            {t("need_permissions")}
          </Typography>
          <Typography className="need-permissions-screen-desc">
            {t("need_permissions_description")}
          </Typography>
        </Box>
      </Box>

      <Box className="access-container">
        <Typography className="need-to-assess-text">
          {t("we_need_to_access")}
        </Typography>
        <Box className="need-assess-container">
          <NeedAssessComponent
            icon={<FmdGoodIcon />}
            heading={t("location_access")}
            content={t("location_access_description")}
          />
          <Divider className="divider" />
          <NeedAssessComponent
            icon={<MicIcon />}
            heading={t("microphone_access")}
            content={t("microphone_access_description")}
          />
        </Box>
        <Box className="need-assess-container">
          <NeedAssessComponent
            icon={<GppGoodIcon />}
            heading={t("data_security")}
            content={t("data_security_description")}
          />
        </Box>
        <Box style={{ textAlign: "center" }}>
          <Button
            variant="contained"
            disableElevation
            className="button-component"
            onClick={askPermissions}
          >
            {t("i_approve")}
          </Button>
        </Box>
      </Box>
      <Box className="cloudsBottomOrange">
        <img src={CloudOrange} alt="orange-cloud-img" />
      </Box>
    </Box>
  );
};

export default NeedPermissionsScreen;
